function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.063 2.25h-1.688V.281A.282.282 0 0012.094 0h-.563a.282.282 0 00-.281.281V2.25H4.5V.281A.282.282 0 004.219 0h-.563a.282.282 0 00-.281.281V2.25H1.687C.756 2.25 0 3.006 0 3.938v12.374C0 17.244.756 18 1.688 18h12.374c.932 0 1.688-.756 1.688-1.688V3.938c0-.931-.756-1.687-1.688-1.687zm.562 14.063c0 .309-.253.562-.563.562H1.688a.564.564 0 01-.563-.563V6.75h13.5v9.563zm0-10.688h-13.5V3.937c0-.309.253-.562.563-.562h12.374c.31 0 .563.253.563.563v1.687zM3.937 13.5h3.376c.309 0 .562-.253.562-.563V9.563A.564.564 0 007.312 9H3.938a.564.564 0 00-.562.563v3.374c0 .31.253.563.563.563zm.563-3.375h2.25v2.25H4.5v-2.25z",
  fill: "#111"
});

function SvgDateAvailableIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    fill: "none"
  }, props), _ref);
}

export default SvgDateAvailableIcon;